import React from 'react';
import { Dayjs } from 'dayjs';
import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { monthsArabic } from '../../Constants';
import { toArabicNumerals } from '../../Helpers';
import { useTranslate } from '@refinedev/core';

interface CalendarHeaderProps {
  value: Dayjs;
  onChange: (value: Dayjs) => void;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({ value, onChange }) => {
  const monthIndex = value.month();
  const month = monthsArabic[monthIndex];
  const year = value.year();
  const translate = useTranslate();

  const handlePrevMonth = () => {
    onChange(value.clone().subtract(1, 'month'));
  };

  const handleNextMonth = () => {
    onChange(value.clone().add(1, 'month'));
  };
  const isRTL = document.documentElement.dir === 'rtl';
  return (
    <div className="flex flex-col gap-3 my-3">
      <div className="flex justify-between custom-calendar-header">
        <Button
          className={`border-none shadow-none ${!isRTL ? 'rotate-180' : ''}`}
          onClick={handleNextMonth}
          icon={<RightOutlined />}
        />
        <div className="month-year">{`${month} ${year}`}</div>
        <Button
          className={`border-none shadow-none ${!isRTL ? 'rotate-180' : ''}`}
          onClick={handlePrevMonth}
          icon={<LeftOutlined />}
        />
      </div>
      <div className="flex justify-between gap-4">
        <div className="text-gunmetal-gray font-semibold rounded-md border border-solid border-gray-300 bg-white shadow-xs py-2.5 px-3.5">
          {translate('common.today')}
        </div>
        <div className="w-full text-textPrimary900  rounded-md border border-solid border-gray-300 bg-white shadow-xs py-2 px-3.5">
          {`${toArabicNumerals(value.date())} ${monthsArabic[value.month()]} ${toArabicNumerals(year)}`}
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;
